import {
  ComponentValidationError,
  ValidationError,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/component-validations/types';
import { getComponentDisplayName } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/utils';
import { getDisplayNameForStep } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenEditor/utils';
import { InquiryTemplateVersionStepUi } from 'dashboard/models/inquiry-template-version';
import { isUiParentComponentConfig, UiComponentConfig } from 'lib/interfaces/ui-components';

type ValidateParentComponentConfigProps = {
  componentConfig: UiComponentConfig;
  step: InquiryTemplateVersionStepUi;
};

const validateParentComponentConfig = ({
  componentConfig,
  step,
}: ValidateParentComponentConfigProps): ComponentValidationError[] => {
  if (!isUiParentComponentConfig(componentConfig)) return [];
  const errors: ComponentValidationError[] = [];
  if (componentConfig.config.children.length === 0) {
    errors.push({
      type: ValidationError.ParentMissingChildren,
      message: `${getComponentDisplayName(componentConfig)} component in "${getDisplayNameForStep(
        step,
      )}" cannot be empty`,
      componentType: componentConfig.type,
      stepName: step.name,
    });
  }

  return errors;
};

export default validateParentComponentConfig;
